import { ELEMENT_TYPES } from 'cg/components/documents/editor/slate/types'
import { Node } from 'vendor/slate'

const HEADING_PATTERN = /^(#{1,2})[ \t]+(.+?)\s*#*\s*$/

export const extractRawMarkdownHeadings = markdown => {
  if (!markdown) return []

  const headings = []
  let inFence = false

  String(markdown)
    .split(/\r\n|\r|\n/)
    .forEach(line => {
      if (/^\s*(```|~~~)/.test(line)) {
        inFence = !inFence
        return
      }
      if (inFence) return

      const match = line.match(HEADING_PATTERN)
      if (!match) return

      headings.push({
        type: match[1].length === 1 ? ELEMENT_TYPES.header_one : ELEMENT_TYPES.header_two,
        children: [{ text: match[2].trim() }]
      })
    })

  return headings
}

export const extractDocumentToc = nodes =>
  (Array.isArray(nodes) ? nodes : []).flatMap(node => {
    if ([ELEMENT_TYPES.header_one, ELEMENT_TYPES.header_two].includes(node?.type)) return [node]
    if (node?.type === ELEMENT_TYPES.raw_markdown) {
      return extractRawMarkdownHeadings(Node.string(node))
    }
    return []
  })
